'use strict';

/**
 * FE logic for navigation-accordion PD component
 */

const isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth');

const genericNavAccordion = {
    init : function() {
        handleScreenSize();

        $(document).on('click', '.js-generic-nav-button', function () {
            setActiveTopicDesktop($(this).data('topic-header'));
        });

        $(document).on('change', '.js-dropdown-select', function () {
            setActiveTopicMobile($(':selected', $(this)).data('topic-header'));
        });

        $(document).off('click', '.js-generic-acc-head-button').on('click', '.js-generic-acc-head-button', function(e) {
            accordionToggle($(e.target));
        });


        $('a[data-link-label="cookie-settings"], a[href="cookie-settings"]')
            .addClass('optanon-toggle-display')
            .attr('href', 'javascript:void(0);')
            .attr('onclick', 'OneTrust.ToggleInfoDisplay(); return false');

        $('.optanon-toggle-display').attr('onclick', 'OneTrust.ToggleInfoDisplay(); return false');

        $(document).on('click', 'a[data-link-label="cookie-settings"]', function (e) {
            e.preventDefault();
        });


        let isTouchScrolling = false;
        let isScrolling = false;
        $(window).on('scroll', function() {
            isScrolling = true;
        });
        $(window).on('touchmove', function() {
            isTouchScrolling = true;
        });
        $(window).on('resize', function() {
            //Touch scrolling causes an misleading resize event on IOS
            if (!isTouchScrolling && !isScrolling){
                handleScreenSize();
                isScrolling = false; //reset scrolling flag
            }
        });
        $(window).on('touchend', function() {
            setTimeout(function() {
                isTouchScrolling = false; //reset touchScroll flag
            }, 100);
        });
    }
};

function handleScreenSize() {
    if (!isMobileOrTabletWidth()) {
        setActiveTopicDesktop();
    } else {
        setActiveTopicMobile();
    }
}

function setActiveTopicDesktop(topic) {
    const $topicElement = getTopicElement(topic);
    if (!$topicElement) {return;}

    $('button', '.js-generic-nav').removeClass('active');
    $topicElement.addClass('active');
    const $topicBreadcrumbElement = $('.js-breadcrumb-element-topic', '.js-generic-nav');
    $('span', $topicBreadcrumbElement).text($topicElement.data('topic-header'));

    updateAccordion($topicElement);
}

function setActiveTopicMobile(topic) {
    const $topicMobileElement = getTopicMobileElement(topic);
    if (!$topicMobileElement) {return;}

    $('option', '.js-dropdown-select').removeAttr('selected');
    $topicMobileElement.attr('selected', 'selected');

    updateAccordion($topicMobileElement);
}

function getTopicElement(topic) {
    let $topicToBeSelected = $('button[data-topic-header="' + topic + '"]', '.js-generic-nav');
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('button', '.js-generic-nav')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function getTopicMobileElement(topic) {
    let $topicToBeSelected = $('option[data-topic-header="' + topic + '"]','.js-dropdown-select');

    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('option', '.js-dropdown-select')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function updateAccordion(button) {
    const accordionId = $(button).data('accordion-id');
    if (!accordionId) {
        $('.js-generic-accordion-wrapper').empty();
        return;
    }

    const $accordionElement = $('div[data-accordion-id="' + accordionId + '"]').clone();
    if (!$accordionElement || !$accordionElement.length) {
        $('.js-generic-accordion-wrapper').empty();
        return;
    }

    $('.js-generic-accordion-wrapper').empty().append($accordionElement[0]);
    $('.js-generic-accordion-wrapper').children().removeClass('hide');
}

function accordionToggle(button) {
    const accHeadClass = '.js-generic-acc-head';
    const accContentClass = '.js-generic-acc-content';
    const $parent = button.parent(accHeadClass);
    const $siblings = $parent.parent().siblings();

    if (!$parent.hasClass('open-acc')) {
        $siblings.find(accHeadClass).removeClass('open-acc').attr('aria-expanded', 'false');
        $siblings.find(accContentClass).stop().slideUp().attr('aria-hidden', 'true');
        $parent.addClass('open-acc').attr('aria-expanded', 'true');
        $parent.siblings(accContentClass).stop().slideDown().attr('aria-hidden', 'false');
        return;
    }

    $parent.removeClass('open-acc').attr('aria-expanded', 'false');
    $parent.siblings(accContentClass).stop().slideUp().attr('aria-hidden', 'true');
}

module.exports = genericNavAccordion;
